import qs from 'qs';
import moment from 'moment';
import axios, {
  AxiosResponse,
  CancelToken,
  CancelTokenSource
} from 'axios';

import Logger from './logger';
import Storage from './storage';
import { Config } from '../config';

export type TAPIRequestCanceller = CancelTokenSource;
export type TAPIResponse = AxiosResponse;
type TErrorResponseCallback = (error: Error | null, res: any) => void;

const log = new Logger('API');

const extractParams = (route) => {
  const matches = (route.match(/\{[^\}]+\}/g)) || [];
  return matches.map(m => m.replace(/[\{\}]*/g, ''));
};

const CACHE_EXPIRY = 6;
const CACHE_EXPIRY_UNIT = 'hours';

export default class API {
  private _apiURL = Config.API_URL;

  private static cacheResponse(endpoint: string, data: any) {
    data.exp = moment().add(CACHE_EXPIRY, CACHE_EXPIRY_UNIT);
    Storage.set(`cache.${endpoint}`, data);
  }

  private static async request(
    method: string,
    cancelToken: CancelToken,
    endpoint: string,
    params: object,
    cache: boolean,
    done?: TErrorResponseCallback,
    ...args) {

    // TODO: fix this. kept fetching empty data because it's cached
    //  eg. menus were getting '[]' previously but was populated within the CMS
    // Upon removal of this block, API calls gets a valid dataset
    // try {
    //   const cachedData = await Storage.get(`cache.${endpoint}`);
    //   const expired = !!cachedData && moment(cachedData.exp).isBefore(moment());
    //   if (cachedData && !expired && done) {
    //     return done(null, { data: cachedData });
    //   }
    // } catch (e) {
    //   log.error('Error retrieving cached API response:', e.message);
    // }

    params['app_id'] = Config.API_APP_ID;

    let request = {
      method,
      cancelToken,
      params,
      url: `${Config.API_URL}/${endpoint}`,
      paramsSerializer: qs.stringify,
      headers: {
        'Content-Type': 'application/json; charset=utf-8'
      }
    } as any;

    const tokenIndex = args.indexOf('token');
    if (tokenIndex !== -1) {
      request = {
        ...request,
        headers: {
          ...request.headers,
          Authorization: args[tokenIndex]
        }
      };
    }

    if (method !== 'GET') {
      request.data = params;
    }

    axios(request)
      .then(async (r: AxiosResponse) => {
        if (cache) {
          try {
            await this.cacheResponse(endpoint, r.data);
          } catch (e) {
            log.error('Error caching response:', e.message);
          }
        }
        if (done) return done(null, r);
        log.info(`Received data from /${endpoint}`);
      })
      .catch((err) => {
        if (done) return done(err, null);
        log.error(`Error fetching from /${endpoint}:`, err.message);
      });
  }

  public static newRequestCanceller(): CancelTokenSource {
    return axios.CancelToken.source();
  }

  public static get(
    canceller: TAPIRequestCanceller,
    endpoint: string,
    params: object = {},
    cache: boolean,
    done?: TErrorResponseCallback,
    ...args) {
    this.request('GET', canceller.token, endpoint, params, cache, done, ...args);
  }

  public static post(
    canceller: TAPIRequestCanceller,
    endpoint: string,
    params: object = {},
    done?: TErrorResponseCallback,
    ...args) {
    const CACHE = false;
    this.request('POST', canceller.token, endpoint, params, CACHE, done, ...args);
  }
}



// WEBPACK FOOTER //
// ./src/services/api.ts